// extracted by mini-css-extract-plugin
export default {"tasksPage":"AllProjectTasksPage_tasksPage__3Rwnt","tasksGrid":"AllProjectTasksPage_tasksGrid__t-BfH","task":"AllProjectTasksPage_task__7LGlB"};